import React from 'react';

import {
  Row,
  Col,
  Button,
  Form,
} from 'react-bootstrap';
import styled from 'styled-components';

import { 
  Popover,
  Tooltip,
} from 'antd';

import CurrencyInput from 'react-currency-input-field';

// Redux
import { useDispatch, useSelector } from "react-redux";
import { RootState } from '../../../../../setup'
import { fields } from '../slice.tsx';
import taxRateSlice from "../../../utils/slices/taxRate.tsx";

import { AccountSettingType } from '../../../utils/enums.tsx';

import { ReactComponent as XIcon } from "../../../../v5/assets/icons/x.svg";
import { ReactComponent as SettingsIcon } from "../../../../v5/assets/icons/settings.svg";

// ----------------------------------------------------------------------

const StyledA = styled.a`
  svg {
    path {
      stroke: var(--bs-blue-500);
    }
  }

  &:hover {
    svg {
      path {
        stroke: var(--bs-gray-700);
      }
    }
  }
`;


export default function FormElement({ onSave }: any) {
  const [open, setOpen] = React.useState(false);
  const [val, setVal] = React.useState('');
  const inputRef = React.useRef<HTMLInputElement>(null);

  const dispatch = useDispatch();
  const { isLoading, defaultTaxRate } = useSelector((state: RootState) => state.taxRateSlice);

  
  React.useEffect(() => {
    if(open){
      setVal('');

      dispatch(taxRateSlice.getDefaultTaxRateApi((state: boolean, data: any) => {
        // if(state){
        //   setVal(data?.value || '');
        // } else {
        //   setVal('');
        // }

        setTimeout(() => {
          if(inputRef && inputRef.current){
            inputRef.current.focus();
          }
        }, 0);
      }));
    }
  }, [open]);


  const hide = () => {
    setOpen(false);
    setVal('');
  };

  const save = () => {
    if(!checkIsNotTaxRateBetween0and100(val)){
      let params = {
          type: AccountSettingType.DefaultTaxRate,
          value: val,
      }
      dispatch(taxRateSlice.callSaveDefaultTaxRateApi(params, (state: boolean, data: any) => {
        if(state){
          dispatch(taxRateSlice.setDefaultTaxRate((val && val != '') ? val : ''));

          if(onSave){
            onSave(val);
          }
          
          hide();
        }
      }));
    }
  };


  const checkIsNotTaxRateBetween0and100 = (value: any) => {
    const numericValue = parseFloat(value || '0');
    if (numericValue >= 0 && numericValue <= 100) {
      return false
    } else {
      return true
    }
  }


  return <Popover
    rootClassName='wp-v5'
    open={open}
    onOpenChange={(newOpen: boolean) => {
      setOpen(newOpen);
    }}

    content={<div style={{ minWidth: '280px' }}>
      <Row className='align-items-center g-0 p-16 pb-0'>
        <Col xs={true} className='fw-medium text-center'>{fields.defaultTaxRate.title}</Col>
        <Col xs={'auto'}>
          <Button
            className='mb-1'
            size={'sm'}
            variant={'custom-none-primary'}
            onClick={(e) => { 
              e.preventDefault();
              e.stopPropagation();

              hide();
            }}
          >
            <XIcon />
          </Button>
        </Col>
      </Row>
      
      <Row className='align-items-center g-0 p-16 pt-18'>
        <Col xs={12}>
          <Form.Group>
            {/* <Form.Label className='xsmall fw-bold'>{fields.defaultTaxRate.label}</Form.Label> */}
            <Form.Control
              ref={inputRef}
              autoFocus
              
              as = {CurrencyInput}
              isInvalid={!isLoading && checkIsNotTaxRateBetween0and100(val)}
              
              allowDecimals={true}
              allowNegativeValue={false}
              disableGroupSeparators={true}
              suffix={'%'}

              id={fields.defaultTaxRate.id}
              placeholder={defaultTaxRate + '%'}
              disabled={isLoading}
              value={isLoading ? '' : val}
              onValueChange={async (newVal: any) => {
                setVal((newVal && newVal != '') ? newVal : '');
              }}
              onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  e.stopPropagation();

                  save();
                }
              }}
            />
            <Form.Control.Feedback type="invalid">{fields.defaultTaxRate.required}</Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>
      
      <Row className='align-items-center g-12 p-16' style={{ backgroundColor: 'var(--bs-blue-focus1)' }}>
        <Col xs={true}>
          <Button
            className='w-100'
            variant={'custom-outlined'}
            disabled={!(val != '') || isLoading || checkIsNotTaxRateBetween0and100(val)}
            onClick={() => {
              hide();
            }}
          >Cancel</Button>
        </Col>
        <Col xs={true}>
          <Button
            className='w-100'
            variant={'custom-primary'}
            disabled={!(val != '') || isLoading || checkIsNotTaxRateBetween0and100(val)}
            onClick={() => {
              save();
            }}
          >Save</Button>
        </Col>
      </Row>
    </div>}
    arrow={false}
    trigger="click"
    // placement="rightTop"
  >
    <Tooltip title={fields.defaultTaxRate.tooltip} className={'dark-tooltip mb-3'}>
      <StyledA href={'/'}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
      >
        <SettingsIcon />
      </StyledA>
    </Tooltip>
  </Popover>
}
